import React, { useEffect, useState, useContext } from "react";
import BuilderFilter from "./BuilderFilter";
import { BuilderContext } from "./../BuilderContext";

const BuilderCondition = ({
  conditionData,
  setFilterDefinition,
  insideCondition,
  setConditionToFilter,
  updateConditionfunction,
  position,
  toUpdate,
}) => {
  const { filter_template } = useContext(BuilderContext);
  const [firstCondition, setfirstCondition] = useState();
  const [secondCondition, setsecondCondition] = useState();
  const [conditionDataDetail, setConditionDataDetail] = useState();
  const [conditionFunctionData, setConditionFunctionData] = useState(
    conditionData.function
  );

  useEffect(() => {
    if (
      conditionData &&
      JSON.stringify(conditionData) !== JSON.stringify(conditionDataDetail)
    ) {
      setConditionDataDetail(conditionData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conditionData]);

  useEffect(() => {
    if (conditionDataDetail) {
      if (
        conditionDataDetail.conditions &&
        conditionDataDetail.conditions.length === 2
      ) {
        setfirstCondition(conditionDataDetail.conditions[0]);
        setsecondCondition(conditionDataDetail.conditions[1]);
        setConditionFunctionData(conditionDataDetail.function);
      }
      if (insideCondition) {
        updateConditionfunction(conditionDataDetail, position);
      } else {
        setFilterDefinition(conditionDataDetail);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conditionDataDetail]);

  useEffect(() => {
    if (conditionFunctionData) {
      setConditionDataDetail((prev) => {
        return {
          ...prev,
          function: conditionFunctionData,
        };
      });
    }
  }, [conditionFunctionData]);
  const reduce_condition_to_filter = () => {
    if (insideCondition) {
      updateConditionfunction(filter_template, position);
    } else {
      setConditionToFilter(filter_template);
    }
  };
  const updateFilterdetails = (item, pos) => {
    if (
      conditionDataDetail &&
      conditionDataDetail.function &&
      (conditionDataDetail.function === "AND" ||
        conditionDataDetail.function === "OR")
    ) {
      let temp_data = conditionDataDetail.conditions.map((obj, index) => {
        return parseInt(index) === pos ? item : obj;
      });
      setConditionDataDetail((prev) => {
        return {
          ...prev,
          conditions: temp_data,
        };
      });
    }
  };
  const updateCondition = (item, pos) => {
    if (
      conditionDataDetail &&
      conditionDataDetail.function &&
      (conditionDataDetail.function === "AND" ||
        conditionDataDetail.function === "OR")
    ) {
      let temp_data = conditionDataDetail.conditions.map((obj, index) => {
        return parseInt(index) === pos ? item : obj;
      });
      setConditionDataDetail((prev) => {
        return {
          ...prev,
          conditions: temp_data,
        };
      });
    }
  };
  const remove_filter_inside_condition = (pos) => {
    let updating_detail = firstCondition;
    if (pos === 0) {
      updating_detail = secondCondition;
    }
    if (insideCondition) {
      updateConditionfunction(updating_detail, position);
    } else {
      setConditionToFilter(updating_detail);
    }
  };

  return (
    <React.Fragment>
      <div
        className=""
        style={{
          border: "1px solid #c9cccf",
          borderRadius: "5px",
          position: "relative",
          padding: "10px 12px 10px 20px",
        }}
      >
        {toUpdate && (
          <div
            className="position-absolute"
            style={{ top: "43%", left: "-1.4%" }}
          >
            <button
              data-testid="builder-condition-add-filter-btn"
              className="border btn"
              onClick={reduce_condition_to_filter}
              style={{
                color: "rgb(9, 28, 170)",
                paddingTop: "0px",
                paddingBottom: "0px",
                border: "solid 1px #c9cccf",
                backgroundColor: "white",
                padding: "0px 8px 0px 8px",
              }}
            >
              -
            </button>
          </div>
        )}
        <div className="">
          {conditionDataDetail &&
            firstCondition &&
            secondCondition &&
            conditionFunctionData &&
            firstCondition.function &&
            firstCondition.function === "FILTER" && (
              <BuilderFilter
                filterDetail={firstCondition.filter}
                insideCondition={true}
                setFilterDefinition={setFilterDefinition}
                position={0}
                updateConditionfunction={updateCondition}
                updateFilterdetails={updateFilterdetails}
                remove_filter_inside_condition={remove_filter_inside_condition}
                toUpdate={toUpdate}
              />
            )}

          {conditionDataDetail &&
            firstCondition &&
            secondCondition &&
            conditionFunctionData &&
            firstCondition.function &&
            (firstCondition.function === "AND" ||
              firstCondition.function === "OR") && (
              <div className="">
                <BuilderCondition
                  conditionData={firstCondition}
                  conditionFunction={firstCondition.funtion}
                  insideCondition={true}
                  position={0}
                  updateConditionfunction={updateCondition}
                  toUpdate={toUpdate}
                />
              </div>
            )}
        </div>
        {conditionDataDetail && conditionFunctionData && (
          <div className="form-group mb-3 mt-3">
            <div className="col-md-2 pe-5">
              <select
                className="border-1 form-select ps-4 shadow-none"
                id="conditionFunctionData"
                data-testid="builder-condition-function-select"
                aria-label="conditionFunctionData"
                value={conditionFunctionData}
                disabled={!toUpdate}
                style={{
                  fontSize: ".8rem",
                  color: "black",
                  fontWeight: "500",
                  fontFamily: "Noto Sans",
                }}
                onChange={(e) => {
                  setConditionFunctionData(e.target.value);
                }}
              >
                <option value="AND">AND</option>
                <option value="OR">OR</option>
              </select>
            </div>
          </div>
        )}
        <div className="">
          {conditionDataDetail &&
            firstCondition &&
            secondCondition &&
            conditionFunctionData &&
            secondCondition.function &&
            secondCondition.function === "FILTER" && (
              <BuilderFilter
                filterDetail={secondCondition.filter}
                insideCondition={true}
                setFilterDefinition={setFilterDefinition}
                position={1}
                updateConditionfunction={updateCondition}
                updateFilterdetails={updateFilterdetails}
                remove_filter_inside_condition={remove_filter_inside_condition}
                toUpdate={toUpdate}
              />
            )}
          {conditionDataDetail &&
            firstCondition &&
            secondCondition &&
            conditionFunctionData &&
            secondCondition.function &&
            (secondCondition.function === "AND" ||
              secondCondition.function === "OR") && (
              <div className="">
                <BuilderCondition
                  conditionData={secondCondition}
                  conditionFunction={secondCondition.funtion}
                  insideCondition={true}
                  position={1}
                  updateConditionfunction={updateCondition}
                  toUpdate={toUpdate}
                />
              </div>
            )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default BuilderCondition;
